import secureCookieStorage from "@gerenciatd/next13.utils.secure.local-storage";

/**
 * Comprueba si han transcurrido al menos seis meses entre dos fechas.
 * @param {number} desde - Fecha inicial en milisegundos.
 * @param {number} hasta - Fecha final en milisegundos (actualmente).
 * @returns {boolean} - true si han transcurrido seis meses, false si no.
 */
export const hanTranscurridoSeisMeses = (desde, hasta) => {
  const seisMesesEnMilisegundos = 6 * 30 * 24 * 60 * 60 * 1000; // Asumiendo meses de 30 días
  return hasta - desde >= seisMesesEnMilisegundos;
};

/**
 * Obtiene la información persistida del usuario, verificando si han transcurrido seis meses
 * desde la última actualización. En caso afirmativo, limpia la información.
 * @returns {Object} - Información persistida del usuario.
 */
export const getUserPersistedInfo = () => {
  const secureCookieStorageLib = new secureCookieStorage();
  let persistedInfo2Use = {};
  let persistedInfo = secureCookieStorageLib.getItem("ts");

  if (persistedInfo && persistedInfo.ts) {
    const currentDate = Date.now();
    const lastTs = persistedInfo.ts;

    // Verificar si han transcurrido seis meses
    const checkSeisMeses = hanTranscurridoSeisMeses(lastTs, currentDate);

    if (checkSeisMeses) {
      // Limpiar la información si han pasado seis meses
      persistedInfo = {};
      localStorage.removeItem("ts");
    } else {
      // Utilizar la información persistida si no han pasado seis meses
      persistedInfo2Use = { ...persistedInfo };
    }
  }

  return persistedInfo2Use;
};
